import { useCallback, useEffect, useState } from 'react'
import divisionApi, { DivisionProps } from '../../../../lib/functions/division'

type ProgramMasterData = {
  divisions: DivisionProps[]
  loaded: boolean
}

export const useProgramMasterData = (): ProgramMasterData => {
  const [divisions, setDivisions] = useState<DivisionProps[]>([])
  const [loaded, setLoaded] = useState(false)

  const fetchMasterData = useCallback(async () => {
    const divisions = await divisionApi.findAll()
    setDivisions(divisions)
    setLoaded(true)
  }, [])

  useEffect(() => {
    fetchMasterData()
  }, [fetchMasterData])

  return { divisions, loaded }
}
